import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
import { badgeClasses, BadgeProps as MuiBadgeProps } from '@mui/material/Badge';
import { CircularProgressProps as MuiCircularProgressProps } from '@mui/material/CircularProgress';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { avatarClasses } from '@mui/material/Avatar';
import { MuiBadge, MuiCircularProgress } from '../../../../../modules/material';
import { IconProgressProps } from './index';

export const StyledProgressBadge = styled(MuiBadge, {
  shouldForwardProp: (prop: string) => !['enableAvatarView'].includes(prop),
})<MuiBadgeProps & Pick<IconProgressProps, 'enableAvatarView'>>((props) => {
  const { theme, enableAvatarView } = props;
  const badgeOffset = enableAvatarView ? 8 : 5;

  return {
    [`& .${badgeClasses.badge}`]: {
      width: '20px',
      minWidth: '20px',
      height: '20px',
      bottom: `8px`,
      right: `${badgeOffset}px`,
      border: `2px solid ${theme.palette.neutral[0]}`,
      boxSizing: 'border-box',
    },
  };
});

export const StyledIconWrapper = styled('div', {
  shouldForwardProp: (prop: string) =>
    !['enableAvatarView', 'backgroundRGBColor', 'opacity'].includes(prop),
})<
  Partial<
    Pick<
      IconProgressProps,
      'enableAvatarView' | 'backgroundRGBColor' | 'opacity'
    >
  >
>((props) => {
  const { theme, enableAvatarView, backgroundRGBColor, opacity } = props;
  const wrapperSize = enableAvatarView
    ? 'var(--payment-component-avatar-progress-size)'
    : 'var(--payment-component-icon-progress-size)';
  const borderWidth = enableAvatarView ? 3 : 2;

  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: wrapperSize,
    height: wrapperSize,
    borderRadius: '50%',
    boxSizing: 'border-box',
    border: `${borderWidth}px solid ${theme.palette.neutral[200]}`,
    ...(backgroundRGBColor && {
      backgroundColor: `rgba(${backgroundRGBColor}, ${opacity})`,
    }),
  };
});

export const StyledIconProgressIconContainer = styled('div', {
  shouldForwardProp: (prop: string) =>
    !['enableAvatarView', 'color'].includes(prop),
})<Pick<IconProgressProps, 'enableAvatarView' | 'color'>>((props) => {
  const { theme, enableAvatarView, color } = props;

  const avatarExtraRules = enableAvatarView
    ? {
        border: `2px solid ${theme.palette.neutral[0]}`,
        borderRadius: '50%',

        [`& .${avatarClasses.root}`]: {
          height: '100%',
          width: '100%',
          backgroundColor: 'transparent',
          color: color || theme.palette.neutral[600],
        },
      }
    : {};

  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    lineHeight: '100%',
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
    color: color || theme.palette.neutral[600],
    fontSize: enableAvatarView ? '22px' : '16px',
    fontWeight: 700,
    ...avatarExtraRules,
  };
});

export const StyledCircularProgress = styled(
  MuiCircularProgress,
)<MuiCircularProgressProps>((props) => {
  const { theme } = props;

  return {
    color: theme.palette.customSuccess.mainCustom,
    position: 'absolute',
  };
});

export const StyledCheckIcon = styled(CheckIcon)<SvgIconProps>(() => {
  return {
    fontSize: '14px',
    fontWeight: 900,
  };
});
